<template>
    <div id="factorServices">
        <!--banner区域-->
        <div class="bannerWrap">
            <div class="contentWrap">
                <div class="content">
                    <div class="contentTitle">因子服务</div>
                    <div class="contentVal">
                        <span>对多维度的信息标签降维分析</span>
                        <span>辅助企业、券商高效、精准地展开业务分析</span>
                    </div>
                    <button class="btn" @click="showAlertFlag=true">立即咨询</button>
                </div>
                <!--右侧动效图片-->
                <div class="rightAImg">
                    <img src="../../assets/img/factorServices/内圈.png" class="inImg" alt=""/>
                    <img src="../../assets/img/factorServices/中圈.png" class="centerImg" alt=""/>
                    <img src="../../assets/img/factorServices/外圈.png" class="outImg" alt=""/>
                </div>
            </div>
        </div>
        <!--内容区-->
        <div class="factorServicesConWrap">
            <!--例子-->
            <div class="exampleBox">
                <div class="left">
                    <div class="leftList" v-for="(item,index) in leftData" :key="index">
                        <div class="name">
                            {{item.name}} <span>{{item.work}}</span>
                        </div>
                        <div class="wordWrap" v-html="item.val"></div>
                    </div>
                </div>
                <div class="right">
                    <div class="rightTitle">因子服务的应用无处不在，只是您没察觉</div>
                    <div class="rightList" v-for="(item,index) in rightData" :key="index"
                         @click="chooseExampleEvent(index)">
                        <span></span>
                        <p v-html="item.val"></p>
                    </div>
                </div>
            </div>
            <!--产品设计-->
            <div class="productWrap">
                <div class="headline">产品设计</div>
                <div class="productBox">
                    <div class="listBox" :class="proIndex===1 ? 'active' : '' " @mouseover="proEvent(1)">
                        <div class="proTitle">
                            <img src="../../assets/01.png" v-show="proIndex!==1"/>
                            <img src="../../assets/01焦点.png" v-show="proIndex===1"/>
                            <span>对各行业参数进行优化</span>
                        </div>
                        <div class="proEnTitle">OPTIMIZE AND CLASSIFY DATA ACROSS INDUSTRIES</div>
                        <div class="proVal" v-show="proIndex===1">
                            基于海量参数，利用神经网络计算技术整合参数，用于因子的指标加权计算，构建基础因子。呈现降维指数，根据指数掌握各行业发展趋势
                        </div>
                    </div>
                    <div class="listBox" :class="proIndex===2 ? 'active' : '' " @mouseover="proEvent(2)">
                        <div class="proTitle">
                            <img src="../../assets/02.png" v-show="proIndex!==2"/>
                            <img src="../../assets/02焦点.png" v-show="proIndex===2"/>
                            <span>挖掘创新性因子</span>
                        </div>
                        <div class="proEnTitle">MINING INNOVATION FACTORS</div>
                        <div class="proVal" v-show="proIndex===2">
                            针对不同层次业务需求响应，基于基础因子结合经济理论分析，机器自动计算并匹配适合的指标因子，然后用商业结果参数对其进行有效性检验。辅助企业预测行业发展趋势，在重要峰值或谷值作出业务调整
                        </div>
                    </div>
                    <div class="listBox" :class="proIndex===3 ? 'active' : '' " @mouseover="proEvent(3)">
                        <div class="proTitle">
                            <img src="../../assets/03.png" v-show="proIndex!==3"/>
                            <img src="../../assets/03焦点.png" v-show="proIndex===3"/>
                            <span>因子跟踪</span>
                        </div>
                        <div class="proEnTitle">PERIODIC FACTORS TRACKING</div>
                        <div class="proVal" v-show="proIndex===3">
                            定期跟踪各类因子表现，包含因子收益、因子风险以及因子热度等多维度评估因子的辅助作用，用于动态调整因子的理论分析与设计策略
                        </div>
                    </div>
                </div>
            </div>
            <!--应用价值-->
            <div class="applicationValue">
                <div class="headline" style="margin-bottom: 50px;">应用价值</div>
                <div class="applicationValueBox">
                    <div class="applicationValueList">
                        <img src="../../assets/img/factorServices/市场分析.png"/>
                        <div class="listTitle">市场分析</div>
                        <div class="listVal">
                            将消费者习惯和态度研究（U&A）、品牌形象和特性研究、服务质量调查、个性测试、形象调查、市场划分识别、顾客、产品和行为通过机器学习进行因子归类分析、通过因子得分可以得出不同因子的重要性指标，而管理者则可根据这些指标的重要性来决定首先要解决的市场问题或产品问题
                        </div>
                    </div>
                    <div class="applicationValueList">
                        <img src="../../assets/img/factorServices/金融行业.png"/>
                        <div class="listTitle">金融行业</div>
                        <div class="listVal">
                            基于因子分析，从盈利能力、偿债能力、运营能力三个方面指标体系进行分析归类，可以反映一个公司是否具有投资的价值，将公司评价指标综合为几个公共因子，得到各个公司的综合得分情况，选取得分较高的公司进行投资组合。为券商或投资机构作决策支撑
                        </div>
                    </div>
                </div>
            </div>
            <!--案例-->
            <div class="caseWrap">
                <div class="headline">案例</div>
                <div class="caseBox">
                    <div class="caseList">
                        <img src="../../assets/img/exampleImg/某地产公司的财务报告分析.png" class="leftImg"/>
                        <div class="rightVal">
                            <div class="rightValTitle">某地产公司的财务报告分析</div>
                            <div class="rightValText">
                                某知名商业地产公司采用因子分析法对年度财务报告进行分析，对公司近六年来的盈利能力、资产管理能力、偿债能力等方面的变动趋势进行分析．重点检验公司在过去一年经营管理中所处的不利局面，并据以对公司整体绩效进行客观而公允的评价
                            </div>
                        </div>
                    </div>
                    <div class="caseList">
                        <img src="../../assets/img/exampleImg/某企业的银行业绩评价模型.png" class="leftImg"/>
                        <div class="rightVal">
                            <div class="rightValTitle">某企业的银行业绩评价模型</div>
                            <div class="rightValText">
                                某企业基于因子分析的基本原理,选取8个指标,分别从盈利能力指标、经营增长指标、资产质量指标和偿付能力指标四个方面构建某证券交易所上市的21家金融银行经营业绩的评价模型,并对其进行分析。同时根据各银行财务指标的综合绩效因子得分排名,提出可能的解释和建议
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--相关产品-->
            <div class="relevantProduct">
                <div class="headline">相关产品</div>
                <!--产品列表-->
                <div class="relevantProductListWrap">
                    <div class="relevantProductList" @click="toPage('/smartLabel')" style="margin-right: 114px;">
                        <img src="../../assets/img/bigIcon/智能标签.png"/>
                        <span>智能标签</span>
                    </div>
                    <div class="relevantProductList" @click="toPage('/modelFactory')" style="margin-right: 98px;">
                        <img src="../../assets/img/bigIcon/模型工厂.png"/>
                        <span>模型工厂</span>
                    </div>
                    <div class="relevantProductList" @click="toPage('/znkqdcSystem')">
                        <img src="../../assets/img/bigIcon/智能客群洞察系统.png"/>
                        <span>客群洞察系统</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="alertBox" v-show="showAlertFlag">
            <div class="alertBoxHeader">
                <span>服务咨询</span>
                <img src="../../assets/关闭.png" height="11" width="11" @click="showAlertFlag=false"/>
            </div>
            <div class="alertBoxVal">
                <div>为您提供售前购买咨询、产品推荐等</div>
                <p>电话：<span>0755-86969845</span>（工作日 9:30-18:30）</p>
                <p>微信：ylw2539</p>
                <p>邮箱：yu@houselai.com</p>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "factorServices",
        data() {
            return {
                proIndex: 1,
                /*数据*/
                rightData: [
                    {val: "知道数据因子对证券市场的重要性吗？"},
                    {val: "应用“心理学、社会学、经济学等领域”的企业都要应用因子服务"},
                ],
                allData: {
                    0: [
                        {
                            name: "田女士", work: "某证券公司分析师",
                            val: "千变万化、不可预测和急剧波动的股票市场使得投资者总感觉猝不及防,毫无应对之策，" +
                                "如何在众多的公司中选择出业绩较优、收益较好的公司，如何在挑选出的优质股票中进行" +
                                "投资比例的分配，是所有理性投资人关心的问题<br/>" +
                                "通过因子分析、非线性规划等方法，对投资者如何在众多公司中选择优质股票，如何" +
                                "在选择的优质股票中进行投资比例分配提供更好的决策方法"
                        },
                        {
                            name: "冀先生", work: "某金融公司部门经理",
                            val: "一般投资者可从有关网站及报刊获取上市公司的财务报表，可是财务报表包含的信息" +
                                "非常多，投资这如果要作出正确的判断，就必须对这些繁杂的信息进行提炼，对股票投资" +
                                "价值作出综合评价<br/>" +
                                "通过降维和信息浓缩技术，量化财务报表里的重要指标，使用因子分析方法对证券市场进" +
                                "行综合评价"
                        },
                        {
                            name: "张女士", work: "某投资机构经理",
                            val: "基于因子分析对证券公司的竞争力进行研究，过去的证券公司大多以单项指标作为分析" +
                                "指标，主观确定各关键因素，难以综合客观地对市场进行分析，这样会让证券公司的竞争力" +
                                "不稳定<br/>" +
                                "通过因子分析，找到关键因素，定量综合评价的结果可以使证券公司在行业地位中更加明确" +
                                "、清晰，使行业的整体竞争力格局更加集中"
                        }
                    ],
                    1: [
                        {
                            name: "徐女士", work: "某企业分析师",
                            val: "获得企业所属的商户O2O运营数据后，通过分析它们在一段时间内的线上线下行为" +
                                "信息，找出这些变量的共性，降低分析维度得出因子，对商户进行综合评价，可以知道" +
                                "产品运营效果是否达到预期<br/>" +
                                "知道了哪些商家表现优异，哪些商户表现比较差，就可以进行后的详细分析，以提升企" +
                                "业的商业价值，达到某些商业目的"
                        },
                        {
                            name: "戴先生", work: "某创业公司总经理",
                            val: "每个行业的商业研究研究可能需要设计大量的变量，其中部分变量是强相关的，因" +
                                "此需要将变量的数量缩减到合适的水平以便进一步分析，通过降维将相关性高的变量聚" +
                                "在一起，从而减少需要分析的变量的数量，而减少研究分析的复杂性<br/>" +
                                "营销研究可以用因子分析确定细分顾客的潜在变量、确定消费者选择的品牌属性，广告研究" +
                                "可以用来分析目标媒体的消费习惯，价格研究可以用于发现敏感的顾客的主要特征"
                        },
                        {
                            name: "高先生", work: "某行业资深从业者",
                            val: "行业的市场表现受到，经济增长、商业周期、通货膨胀、预期收益率等宏观行业" +
                                "因素对各个行业产生不同的影响，行业的发展的成长速度、盈利能力、运营能力、" +
                                "收益质量等基本面指标预期和市场估值和背后的因子具有因果关系<br/>" +
                                "行业多因子模型就是通过对这些因素进行量化描述，分析其与行业市场表现的相关性" +
                                "，提取若干具有显著影响的因子构建行业投资价值的分析评估体系"
                        }
                    ],
                },
                leftData: [],
                showAlertFlag: false
            }
        },
        created() {
            /*初始化案例*/
            this.leftData = this.allData[0];
        },
        mounted() {
            /*淡入淡出效果*/
            window.addEventListener('scroll', this.scrollFun);
            this.scrollFun();
        },
        methods: {
            proEvent(index) {
                this.proIndex = index;
            },
            toPage(page) {
                this.$router.push({path: page});
            },
            scrollFun() {
                this.$animate(document.getElementsByClassName("content")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("exampleBox")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("productWrap")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("applicationValue")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("caseWrap")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("relevantProduct")[0], "fadeInUp");
            },
            /*切换案例数据*/
            chooseExampleEvent(index) {
                this.leftData = this.allData[index];
            }
        },
        beforeDestroy() {
            /*销毁监听*/
            window.removeEventListener('scroll', this.scrollFun);
        }
    }
</script>

<style lang="scss" scoped>
    #factorServices {
        .bannerWrap {
            background: url("../../assets/img/factorServices/因子服务bg.png") no-repeat center;
            background-color: #00051D;

            .rightAImg {
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                top: 50%;
                right: 0;
                transform: translateY(-50%);
                width: 466px;
                height: 466px;

                .outImg {
                    width: 100%;
                    animation: Sanimate 6s linear infinite 0s;
                }

                .centerImg {
                    position: absolute;
                    animation: Nanimate 6s linear infinite 0s;
                }

                .inImg {
                    position: absolute;
                    animation: Sanimate 6s linear infinite 0s;
                }
            }
        }

        .factorServicesConWrap {
            background: url("../../assets/bgImg.png") no-repeat center;
            background-size: cover;
            padding-top: 80px;

            .exampleBox {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                width: 1200px;
                margin: 0 auto 120px;
                padding: 0 0 0 76px;

                .left {
                    width: 458px;
                    margin-right: 128px;
                    padding-top: 44px;

                    .leftList {
                        padding: 20px 20px 20px 31px;
                        margin-bottom: 16px;
                        border-radius: 4px;
                        border: 1px solid #EAEEF4;
                        background: #fff;

                        &:last-child {
                            margin-bottom: 0;
                        }

                        .name {
                            margin-bottom: 4px;
                            font-size: 14px;
                            color: #1B2D35;

                            span {
                                margin-left: 10px;
                                font-size: 12px;
                                color: #40B0FF;
                            }
                        }

                        .wordWrap {
                            opacity: 0.6;
                            margin-bottom: 4px;
                            font-size: 12px;
                            color: #152346;
                            text-align: justify;
                            line-height: 24px;

                            &:last-child {
                                margin-bottom: 0;
                            }
                        }
                    }
                }

                .right {
                    .rightTitle {
                        margin-bottom: 60px;
                        font-size: 30px;
                        color: #152346;
                        white-space: nowrap;
                    }

                    .rightList {
                        display: flex;
                        align-items: center;
                        margin-bottom: 40px;
                        line-height: 22px;
                        cursor: pointer;

                        &:last-child {
                            margin-bottom: 0;
                        }

                        span {
                            display: inline-block;
                            width: 12px;
                            height: 12px;
                            border-radius: 50%;
                            margin-right: 22px;
                            background: #22A5FF;
                        }

                        p {
                            font-size: 16px;
                            color: #152346;
                        }
                    }
                }
            }

            .productWrap {
                .productBox {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 1200px;
                    height: 330px;
                    margin: 70px auto 112px;

                    .listBox {
                        height: 100%;
                        padding: 99px 0 0 40px;
                        cursor: pointer;
                        background: #F6F9FF;
                        flex: 1;
                        transition: all .4s;

                        .proTitle {
                            position: relative;
                            margin-bottom: 32px;
                            font-size: 26px;
                            color: #152346;
                            line-height: 40px;
                            font-weight: bold;

                            span {
                                display: inline-block;
                                position: relative;
                                z-index: 100;
                            }

                            img {
                                position: absolute;
                                left: 0;
                                bottom: 0;

                                &:first-child {
                                    bottom: 5px;
                                }
                            }
                        }

                        .proEnTitle {
                            opacity: 0.3;
                            font-size: 12px;
                            color: #152346;
                            letter-spacing: 0.17px;
                            line-height: 22px;
                        }
                    }

                    .active {
                        min-width: 540px;
                        background: url("../../assets/produceBlueBg.png") no-repeat center;
                        background-size: cover;

                        .proTitle {
                            font-size: 32px !important;
                            color: #FFFFFF;
                            line-height: 40px !important;
                        }

                        .proEnTitle {
                            margin-bottom: 20px;
                            font-size: 14px !important;
                            color: #FFFFFF !important;
                            letter-spacing: 0.4px !important;
                            line-height: 24px !important;
                        }

                        .proVal {
                            padding-right: 40px;
                            font-size: 12px;
                            color: #FDFDFD;
                            line-height: 22px;
                        }
                    }
                }
            }

            .applicationValue {
                .applicationValueBox {
                    display: flex;
                    justify-content: space-between;
                    width: 1200px;
                    padding: 0 100px;
                    margin: 0 auto 130px;

                    .applicationValueList {
                        width: 330px;
                        text-align: center;

                        img {
                            width: 50px;
                            height: 50px;
                            margin-bottom: 24px;
                        }

                        .listTitle {
                            margin-bottom: 12px;
                            font-size: 20px;
                            color: #152346;
                        }

                        .listVal {
                            opacity: 0.7;
                            font-size: 12px;
                            color: #152346;
                            line-height: 22px;
                            text-align: justify;
                        }
                    }
                }
            }

            .caseWrap {
                .caseBox {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 1200px;
                    margin: 0 auto;

                    .caseList {
                        display: flex;
                        align-items: flex-start;

                        .leftImg {
                            width: 192px;
                            height: 186px;
                            margin-right: 16px;
                        }

                        .rightVal {
                            padding-top: 16px;

                            .rightValTitle {
                                opacity: 0.6;
                                margin-bottom: 10px;
                                font-size: 20px;
                                color: #152346;
                            }

                            .rightValText {
                                width: 339px;
                                opacity: 0.4;
                                font-size: 12px;
                                color: #152346;
                                line-height: 24px;
                            }
                        }
                    }
                }
            }

            .relevantProduct {
                width: 436px;
            }
        }
    }

    /*顺时针旋转*/
    @keyframes Sanimate {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }

    /*逆时针旋转*/
    @keyframes Nanimate {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(-360deg);
        }
    }
</style>
